import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

function SectionHeader({ title, subtitle, action }) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                mb: 2,
                gap: 2,
            }}
        >
            <Box>
                <Typography variant="h2" fontWeight={500}>{title}</Typography>
                {subtitle && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
        </Box>
    );
}

export default SectionHeader;
